import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

const getIsSignOut = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.isSignOut || false;
  }
);

export { getIsSignOut };
